export default __webpack_public_path__ + "static/slide6-tablet-b001b5b7d2acf14e49b3d3cbba28c510.png";